import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import dayjs from 'dayjs';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from '../ConfirmCancelDialog';
import { LanguageContext } from '../LanguageContext';
import LocalizedDatePicker from "../LocalizedDatePicker";

const defaultToolbarStyles = {
    iconButton: {
    },
};

var iniPaastoIntensiteetti;

class PaastoIntensiteettiEdit extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        var data = props.Daatta.filter(function (d) {
            return d.riviAvain === props.rowId;
        });

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            data: data,
            RiviAvain: data[0].riviAvain,
            Aika: dayjs(data[0].aika),
            Luokittelu_Id: data[0].luokittelu_Id,
            Luokka_Id: data[0].luokka_Id,
            LuokkaEuro: data[0].luokkaEuro,
            LuokkaCo2: data[0].luokkaCo2,
            Intensiteetti: data[0].intensiteetti,
            Kommentti: data[0].kommentti,
            Created: data[0].created,
            Updated: data[0].updated,
            Username: data[0].username,
            paastoIntensiteetit: (Object.keys(props.lookupLists.paastoIntensiteetit).map((d) => ({ value: d, label: props.lookupLists.paastoIntensiteetit[d] })) || []),
        };

    }

    UNSAFE_componentWillMount() {
        iniPaastoIntensiteetti = this.state.paastoIntensiteetit.find(({ value }) => value === (this.state.RiviAvain || '').toString());
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            RiviAvain: this.state.data[0].riviAvain,
            Aika: dayjs(this.state.data[0].aika),
            Luokittelu_Id: this.state.data[0].luokittelu_Id,
            Luokka_Id: this.state.data[0].luokka_Id,
            LuokkaEuro: this.state.data[0].luokkaEuro,
            LuokkaCo2: this.state.data[0].luokkaCo2,
            Intensiteetti: this.state.data[0].intensiteetti,
            Kommentti: this.state.data[0].kommentti,
            Created: this.state.data[0].created,
            Updated: this.state.data[0].updated,
            Username: this.state.data[0].username
        });
    }

    handleSave = () => {
        this.props.onEditRow({
            RiviAvain: this.state.RiviAvain,
            Aika: this.state.Aika.format("MM/DD/YYYY 00:00:00"),
            Luokittelu_Id: this.state.Luokittelu_Id,
            Luokka_Id: this.state.Luokka_Id,
            LuokkaEuro: (this.state.LuokkaEuro || "").toString().replace(",", "."),
            LuokkaCo2: (this.state.LuokkaCo2 || "").toString().replace(",", "."),
            Intensiteetti: (this.state.Intensiteetti || "").toString().replace(",", "."),
            Kommentti: this.state.Kommentti,
            Created: this.state.Created,
            Updated: this.state.Updated,
            Username: this.state.Username,
        });
        this.handleClearData();
    }

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true })
    }

    handleChangeDate = (name, value) => {
        this.setState({
            [name]: value,
            jotainMuuttui: true
        });
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    render() {
        const { dictionary } = this.context;
        const { open, paastoIntensiteetit } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.Edit}>
                    <IconButton onClick={this.handleClickOpen}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.DataIngestion.PaastoIntensiteetti.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <LocalizedDatePicker
                            label={dictionary.DataIngestion.PaastoIntensiteetti.Columns[1]}
                            value={this.state.Aika}
                            onChange={(newValue) => this.handleChangeDate('Aika', newValue)}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.PaastoIntensiteetti.Columns[2]}
                            type="number"
                            fullWidth
                            value={this.state.Luokittelu_Id}
                            onChange={this.handleChange('Luokittelu_Id')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.PaastoIntensiteetti.Columns[3]}
                            type="number"
                            fullWidth
                            value={this.state.Luokka_Id}
                            onChange={this.handleChange('Luokka_Id')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.PaastoIntensiteetti.Columns[4]}
                            type="number"
                            fullWidth
                            value={this.state.LuokkaEuro}
                            onChange={this.handleChange('LuokkaEuro')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.PaastoIntensiteetti.Columns[5]}
                            type="number"
                            fullWidth
                            value={this.state.LuokkaCo2}
                            onChange={this.handleChange('LuokkaCo2')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.PaastoIntensiteetti.Columns[6]}
                            type="number"
                            fullWidth
                            value={this.state.Intensiteetti}
                            onChange={this.handleChange('Intensiteetti')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.PaastoIntensiteetti.Columns[7]}
                            type="text"
                            fullWidth
                            multiline
                            rows={3}
                            value={this.state.Kommentti}
                            onChange={this.handleChange('Kommentti')}
                        />
                    </DialogContent>
                    {/* TODO:THEME */}
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />
            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "PaastoIntensiteettiEdit" })(PaastoIntensiteettiEdit);
